import { harSupabase, supabase } from "./supabase";

/**
 * Appen faar beskjed naar noe endrer seg, i stedet for aa spoerre etter det.
 *
 * DETTE SNUR EN AVGJOERELSE, og den stod to steder: «Ingen polling» i
 * dokumenteffekten, og «en websocket som ligger og venter i en jakkelomme er
 * feil pris». Begge gjaldt, og begge gjaldt feil tilfelle.
 *
 * Takten paa tretti sekunder hentet ned dokumentlista, beskjedene, shotlista
 * og redaktoerens notater hundre og tjue ganger i timen for aa finne ut at
 * ingenting var nytt. Det er den unoedvendige HENTINGEN som koster — ikke
 * forbindelsen. Et hjerteslag paa en aapen kanal er ett lite bilde hvert 25.
 * sekund; sju spoerringer hvert 30. er noe helt annet.
 *
 * OG DEN LIGGER IKKE I LOMMA. Kanalen aapnes naar skjermen viser appen og
 * lukkes naar den gaar i moerke. Det var den delen av begrunnelsen som
 * holdt.
 *
 * VARSELET ER ET VARSEL, IKKE DATA. Vi leser aldri innholdet i hendelsen —
 * den sier bare «noe endret seg», og flatene henter sitt eget som foer.
 * Da finnes det ingen vei der en endring kan bli halvveis anvendt, og
 * rekkefoelgen mellom to hendelser betyr ingenting.
 *
 * SIKKERHETSNETTET STAAR. Realtime sender ENDRINGER: ligger forbindelsen
 * nede i en kjeller, sier den ingenting om hva man gikk glipp av. Derfor
 * varsler vi ogsaa naar kanalen KOMMER OPP — da er det nettopp et
 * gjensyn — og App beholder en treg takt under. Se nettflatas
 * `state/levende.ts`, som loeste det samme.
 */

/**
 * Tabellene appen leser.
 *
 * `log_entry`, `log_session` og `tc_anchor` staar UTENFOR med vilje. Loggen
 * gaar én vei: opp. Appen tar aldri imot endringer i sin egen logg — se den
 * ufravikelige regelen i CLAUDE.md.
 *
 * `produksjon: false` betyr at tabellen ikke har `production_id` aa filtrere
 * paa. Da kommer hendelser fra andre produksjoner ogsaa; de blir til et
 * varsel for mye og ingenting annet, fordi varselet ikke baerer data. Naar
 * RLS finnes, filtrerer basen dem bort foer de sendes.
 */
const TABELLER: readonly { readonly navn: string; readonly produksjon: boolean }[] = [
  { navn: "document", produksjon: true },
  { navn: "document_series", produksjon: true },
  { navn: "text_page", produksjon: true },
  { navn: "shot_scene", produksjon: true },
  { navn: "shot", produksjon: false },
  { navn: "su_question", produksjon: true },
  { navn: "participant", produksjon: true },
  { navn: "entry_comment", produksjon: false },
  { navn: "entry_mark", produksjon: false },
];

/** Samler opp. En omstokking skriver én rad per linje. */
const PAUSE_MS = 400;

/**
 * Hvor lenge det gaar foer en mislykket henting proeves paa nytt.
 *
 * ET VARSEL BLIR BRUKT OPP. Kommer det inn mens hentingen feiler — svak
 * dekning, en portal som fanger trafikken, et hikk hos tjeneren — er det
 * borte, og kanalen sender det ikke om igjen. Da sto appen med et gammelt
 * bilde til den trege takten slo, i opptil fem minutter, uten at noe sa fra.
 *
 * Maalt: 22 mislykkede forsoek under et brudd, og beskjeden kom ikke fram.
 */
const IGJEN_MS = 20000;

export const HENDELSE = "infoflyt:oppdater";

let igjen = 0;

/**
 * Sier fra at en henting ikke gikk. Varselet gjentas snart.
 *
 * SELVBEGRENSENDE: det planlegges bare naar noe FEILER, og slutter av seg
 * selv saa snart en henting gaar gjennom — da er det ingen som melder fra
 * lenger. Flere feil paa rad blir ett nytt forsoek, ikke sju.
 *
 * MERK HVA SOM ER EN FEIL. Modulene her kaster ikke naar nettet svikter —
 * de returnerer `null`, eller `utenNett: true`. Foerste utgave av dette
 * hang paa `catch`, og fyrte derfor aldri. Kallstedene maa melde fra paa
 * verdien, ikke paa unntaket.
 */
export function proevIgjen(): void {
  if (typeof window === "undefined" || !harSupabase) return;
  window.clearTimeout(igjen);
  igjen = window.setTimeout(() => {
    if (document.visibilityState !== "visible" || !navigator.onLine) return;
    window.dispatchEvent(new CustomEvent(HENDELSE));
  }, IGJEN_MS);
}

/**
 * Aapner kanalen. Returnerer oppsigelsen.
 *
 * Gjoer ingenting uten klient eller uten produksjon — da staar appen paa
 * det lokale, som den skal kunne.
 */
export function startLevende(produksjonId: string): () => void {
  if (supabase === null || produksjonId === "" || produksjonId === "privat") {
    return () => { /* ingenting aa rydde */ };
  }

  let timer = 0;
  const snart = (): void => {
    window.clearTimeout(timer);
    timer = window.setTimeout(() => {
      window.dispatchEvent(new CustomEvent(HENDELSE));
    }, PAUSE_MS);
  };

  const kanal = supabase.channel(`levende:${produksjonId}`);
  for (const t of TABELLER) {
    kanal.on(
      "postgres_changes",
      t.produksjon
        ? {
          event: "*", schema: "public", table: t.navn,
          filter: `production_id=eq.${produksjonId}`,
        }
        : { event: "*", schema: "public", table: t.navn },
      snart,
    );
  }

  kanal.subscribe((status) => {
    /*
     * ET GJENSYN ER OGSAA ET VARSEL.
     *
     * Kom forbindelsen opp igjen etter et brudd, har vi ingen anelse om hva
     * som skjedde mens den laa nede — Realtime sender endringer, ikke
     * tilstand. Da henter vi alt én gang.
     */
    if (status === "SUBSCRIBED") snart();
  });

  return () => {
    window.clearTimeout(timer);
    void supabase?.removeChannel(kanal);
  };
}
